import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { Router } from "@angular/router";
import { LoginStateService } from "../../services/login-state.service";
import { StringService } from "../../services/string.service";
import { BrokerService } from "../../services/broker.service";
import { saveAs } from "file-saver";
import { AuthenticationService } from "../../services/authentication.service";
import { ActivatedRoute } from "@angular/router";

import { FormsModule } from "@angular/forms";

@Component({
  selector: "app-start",
  templateUrl: "./start.component.html",
  styleUrls: ["./start.component.scss"],
  standalone: true,
  imports: [FormsModule],
})
export class StartComponent implements OnInit, OnDestroy {
  public query: string;
  public loading: Boolean = false;
  private subs: Subscription[] = [];

  constructor(
    public loginStateService: LoginStateService,
    public stringService: StringService,
    public router: Router,
    private broker: BrokerService,
    public auth: AuthenticationService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.subs.push(
      this.stringService.connectionStringsChange.subscribe(() =>
        this.cdr.markForCheck(),
      ),
    );
    this.subs.push(
      this.stringService.change.subscribe(() => this.cdr.markForCheck()),
    );
    let code = this.route.snapshot.paramMap.get("code");
    let state = this.route.snapshot.paramMap.get("state");
    if (code && state) {
      try {
        this.loading = true;
        if (state.length % 4 !== 0) {
          for (let i = 0; i < state.length % 4; i++) {
            state += "=";
          }
        }
        if (state === this.auth.getState()) {
          let savedStateObj = JSON.parse(atob(this.auth.getState()));
          this.auth.requestAccessToken(code, savedStateObj.redirect);
        }
      } catch (e) {
        this.loading = false;
      }
    }
  }

  ngOnDestroy() {
    this.subs.forEach((s) => s.unsubscribe());
  }

  public generatePhonebook() {
    this.broker.getPhoneBookFile().subscribe((file: any) => {
      saveAs(file as Blob, "telefonbog.csv");
    });
  }
}
